import { AccessLevel } from "@/api/williams/users";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GlobalSearchResult } from "@/api/williams/search";
import { QualifierUser } from "@/api/user";
import { SpinButton } from "@/components/form/SpinButton";
import { TransferItems } from "./TransferItems";
import { useModalDialog } from "@/hooks";
import { usePermissions, useTransferOwner } from "../../hooks";
import { UserSelectionDialog } from "../../dialogs/UserSelection";
import { useState } from "react";

export type TransferFormProps = {
  user: QualifierUser;
};

export function TransferForm({ user }: TransferFormProps) {
  const [transferFrom, setTransferFrom] = useState(user);
  const [transferTo, setTransferTo] = useState<QualifierUser>();
  const [selectedItems, setSelectedItems] = useState<GlobalSearchResult[]>([]);

  const modal = useModalDialog();
  const transfer = useTransferOwner();
  const permissions = usePermissions();

  function handleTransfer() {
    if (transferTo) {
      transfer.mutate({ transferFrom, transferTo, items: selectedItems });
      setSelectedItems([]);
    }
  }

  function handleSelectFrom() {
    modal.show(UserSelectionDialog, {
      initialUser: transferFrom,
      onAccept: (user) => {
        setTransferFrom(user);
        setSelectedItems([]);
      },
    });
  }

  function handleSelectTo() {
    modal.show(UserSelectionDialog, {
      initialUser: transferTo,
      onAccept: (user) => {
        setTransferTo(user);
      },
    });
  }

  return (
    <div className="mb-5" style={{ maxWidth: 1000 }}>
      <h3>Transfer Ownership</h3>
      <form>
        <div className="row mt-2">
          <div className="col-lg-5">
            {/* Transfer From */}
            <div>
              <label htmlFor="number" className="col-form-label pb-0">
                Transfer From <span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <input type="text" className="form-control" value={transferFrom.name} readOnly />
                {permissions.data?.accessLevel !== AccessLevel.GeneralUser &&
                  permissions.data?.accessLevel !== AccessLevel.WeldingInspector && (
                    <span className="input-group-text" role="button" onClick={handleSelectFrom}>
                      <FontAwesomeIcon size="sm" icon={faMagnifyingGlass} title="Search" />
                    </span>
                  )}
              </div>
            </div>
            {/* Transfer To */}
            <div>
              <label htmlFor="number" className="col-form-label pb-0">
                Transfer To <span className="text-danger">*</span>
              </label>
              <div className="input-group mb-2">
                <input type="text" className="form-control" value={transferTo?.name} readOnly />
                <span className="input-group-text" role="button" onClick={handleSelectTo}>
                  <FontAwesomeIcon size="sm" icon={faMagnifyingGlass} title="Search" />
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-4">
          <TransferItems
            transferFrom={transferFrom}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
          />
        </div>

        <SpinButton
          type="button"
          className="btn btn-default mt-3 mb-4"
          onClick={handleTransfer}
          disabled={!transferTo || selectedItems.length === 0 || transfer.isLoading}
          loading={transfer.isLoading}
        >
          Transfer Selected
        </SpinButton>
      </form>
    </div>
  );
}
